"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeDropdownF = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var actions_1 = require("../constants/actions");
var selectState_1 = require("../state/selectState");
var closeDropdownF = function () {
    var action, closeDropdown, state, currentShowDropdown, isTheSame;
    var _a;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!1) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, effects_1.take)(actions_1.CLOSE_DROPDOWN)];
            case 1:
                action = _b.sent();
                closeDropdown = action.values;
                return [4 /*yield*/, (0, effects_1.select)(selectState_1.selectState)];
            case 2:
                state = _b.sent();
                currentShowDropdown = (_a = state.toggles) === null || _a === void 0 ? void 0 : _a.showDropdown;
                if (!currentShowDropdown) return [3 /*break*/, 4];
                isTheSame = closeDropdown.type === currentShowDropdown.type &&
                    closeDropdown.id === currentShowDropdown.id;
                if (!isTheSame) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, effects_1.put)({
                        type: 'TOGGLE',
                        description: 'closeDropdownF',
                        toggles: {
                            showDropdown: false,
                        },
                    })];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
exports.closeDropdownF = closeDropdownF;
